import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import loadable from '@loadable/component';
import { css, styled } from '@mui/system';
const Dollar = loadable(() => import('@components/Icons/Dollar'));
function shouldForwardProp(propName) {
    return !['centerVertical', 'iconSize', 'iconGap'].includes(propName);
}
const Wrapper = styled('span', { shouldForwardProp }) `
  align-items: center;
  vertical-align: middle;
  display: inline-flex;
  line-height: 1;

  & svg {
    width: ${({ iconSize }) => iconSize}px;
    height: ${({ iconSize }) => iconSize}px;
    margin-right: ${({ iconGap }) => iconGap}px;
  }
  & img {
    width: ${({ iconSize }) => iconSize}px;
    height: ${({ iconSize }) => iconSize}px;
    margin-right: ${({ iconGap }) => iconGap}px;
  }

  ${(props) => props.centerVertical &&
    css `
      display: inline-flex;
      vertical-align: middle;
      padding-bottom: 2px;
    `}
`;
const DollarSymbol = styled('span') `
  margin-right: 0 !important;
`;
const RealMoney = ({ amount, rewardType, className, optimise = false, centerVertical = false, hideIcon = false, withDollarSymbol, iconSize = 18, iconGap = 5, }) => {
    const prizeIcon = rewardType === 'product' ? 'product' : 'dollar';
    return (_jsxs(Wrapper, { iconSize: iconSize, iconGap: iconGap, centerVertical: centerVertical, "data-ignore": true, "data-testid": "USD", className: className, children: [!hideIcon &&
                (optimise ? _jsx("img", { src: `https://static.repeat.gg/rewards/${prizeIcon}.png`, alt: prizeIcon }) : _jsx(Dollar, {})), withDollarSymbol && _jsx(DollarSymbol, { "data-testid": "dollarSymbol", children: "$" }), amount.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: withDollarSymbol ? 0 : 2 })] }));
};
export default RealMoney;
